import { generateID } from '@caresend/utils';
import imageCompression from 'browser-image-compression';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { encryptFile } from '../encryption/encrypt.js';
import { firebaseStorage } from './init.js';

const fileExtension = (file) => file.name.split('.').pop();
const compressFile = async (file, noCompression) => {
    const extension = fileExtension(file);
    if (noCompression || extension === 'svg')
        return file;
    const options = {
        maxSizeMB: 0.7,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
        fileType: file.type,
    };
    try {
        const compressedFile = await imageCompression(file, options);
        return compressedFile;
    }
    catch (error) {
        return file;
    }
};
const uploadFile = async (file, path, setProgress, noCompression, encrypt, accessAttributes, useOriginalFileName) => {
    let fileName = file.name;
    if (!useOriginalFileName) {
        fileName = `${generateID()}.${fileExtension(file)}`;
    }
    const metadata = {
        fileName,
        lastModifiedDate: Date.now(),
        contentType: file.type,
    };
    const pathForStorage = useOriginalFileName ? `${path}/${generateID()}` : path;
    const storageRef = ref(firebaseStorage, pathForStorage);
    const compressedFile = await compressFile(file, noCompression);
    const uploadAction = (inputFile) => {
        const fileRef = ref(storageRef, fileName);
        const uploadTask = uploadBytesResumable(fileRef, inputFile, metadata);
        const encryptionTaskProgress = encrypt ? 20 : 0;
        setProgress === null || setProgress === void 0 ? void 0 : setProgress(encryptionTaskProgress);
        return new Promise((resolve, reject) => {
            uploadTask.on('state_changed', () => {
                const { snapshot } = uploadTask;
                const currentProgress = (snapshot.bytesTransferred / snapshot.totalBytes)
                    * (100 - encryptionTaskProgress) + encryptionTaskProgress;
                setProgress === null || setProgress === void 0 ? void 0 : setProgress(currentProgress);
            }, (error) => reject(error), () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    resolve(downloadURL);
                });
            });
        });
    };
    // Must cast to conditional return types
    if (encrypt) {
        return encryptFile(compressedFile, metadata, uploadAction, accessAttributes);
    }
    return uploadAction(compressedFile);
};
const encryptAndReuploadFromURL = async (url, fileName, path, setProgress, noCompression, accessAttributes, useOriginalFileName) => {
    const file = await fetch(url).then((res) => res.blob());
    const fileObj = new File([file], fileName, { type: file.type });
    return uploadFile(fileObj, path, setProgress, noCompression, true, accessAttributes, useOriginalFileName);
};

export { encryptAndReuploadFromURL, uploadFile };
